// The password policy: checked here before Supabase (whose own minimum is set in the project; docs/deploy.md)
const COMMON = ["password", "123456", "qwerty", "india", "welcome", "admin", "letmein", "iloveyou", "altekore"];
export function passwordProblem(p: string): string | null {
  if (p.length < 10) return "Use at least 10 characters.";
  if (!/[a-z]/i.test(p) || !/[0-9]/.test(p)) return "Use letters and at least one digit.";
  if (COMMON.some((c) => p.toLowerCase().includes(c))) return "That's too easy to guess.";
  if (/^(.)\1+$/.test(p)) return "That's too easy to guess.";
  return null;
}
